query (
  $id: UUID!
){
  sportTemplate: sportTemplateBySportTemplateId(sportTemplateId: $id) {
    sportTemplateId
    name
    createdAt
    createdBy
    updatedAt
    default
    limitconfiguration
    sgpMarginConfiguration
    feedSources
    cashoutEnabled
    sport {
      sportId
      sportName
      sportLabel
    }
    marketConfigurations: marketConfigurationsBySportTemplateId {
      nodes {
        sportsLogicTemplateId
        enabled
        sportLogicTemplate: sportLogicTemplateBySportsLogicTemplateId {
          marketTemplate: marketTemplateByMarketTemplateId {
            template
            marketTemplateId
          }
          name
          marketTemplateId
          defaultDisplayConfiguration
          defaultOfferingConfiguration
          defaultCashoutConfiguration
          defaultResultingConfiguration
          defaultTemplateConfiguration
          defaultLimitConfiguration
          defaultMarginConfiguration
          sportLogicTemplateId
        }
        displayConfiguration
        offeringConfiguration
        cashoutConfiguration
        resultingConfiguration
        templateConfiguration
        limitConfiguration
        marginConfiguration
        disabledSelectionsPreMatch
        disabledSelectionsInPlay
        cutOffConfiguration
        marketVoidProbabilityCutOffConfiguration
      }
    }
    riskConfiguration: riskConfigurationsBySportTemplateId {
      nodes {
        gameRiskTemplateId
        gameRiskConfiguration
        gameRiskTemplate: gameRiskTemplateByGameRiskTemplateId {
          gameRiskTemplateId
          sportId
          name
          rulesSet
          gameRiskHandler
          defaultGameRiskConfig
        }
      }
    }
    arbitrageConfiguration
    topPriceConfiguration
    priceDistanceConfiguration
  }
  availableFeeds: allPrimaryFeeds(condition: {enabled: true}) {
    nodes {
      feed
    }
  }
}
